import React, { useEffect } from "react";
import {
  EthereumClient,
  w3mConnectors,
  w3mProvider,
} from "@web3modal/ethereum";

import { Web3Modal, useWeb3Modal, Web3Button } from "@web3modal/react";

import { configureChains, createClient, WagmiConfig } from "wagmi";
import { arbitrum, mainnet, polygon } from "wagmi/chains";

import Connect from "./Connect";

const WalletConnect = () => {
  const chains = [arbitrum, mainnet, polygon];
  const { open } = useWeb3Modal();

  // Replace with your WalletConnect Project ID
  const projectId = "58a3d4697c7b81981229ed06258993c0";

  // Wagmi client
  const { provider } = configureChains(chains, [w3mProvider({ projectId })]);

  const wagmiClient = createClient({
    autoConnect: true,
    connectors: w3mConnectors({ projectId, version: 1, chains }),
    provider,
  });

  // Web3Modal Ethereum Client
  const ethereumClient = new EthereumClient(wagmiClient, chains);

  useEffect(() => {
    document.title = "Wallet Connect";

    window.addEventListener(
      "showQRCode",
      function () {
        open();
      },
      false
    );
  }, [open]);

  return (
    <div style={{ marginTop: "100px" }}>
      <WagmiConfig client={wagmiClient}>
        {/* Web3Modal ready-made connect button */}
        <Web3Button />
      </WagmiConfig>

      <Web3Modal projectId={projectId} ethereumClient={ethereumClient} />

      <Connect />
    </div>
  );
};

export default WalletConnect;
